module.exports = __webpack_public_path__ + "static/media/02_graph_view.37471ce7.png";